import { useState } from "react";
import { Megaphone, X } from "lucide-react";

export function AnnouncementSketch() {
  const [shown, setShown] = useState(true);
  return (
    <div className="space-y-3 rounded-md border border-dashed border-[#C2A462]/40 bg-card p-5" data-testid="announcement-sketch">
      <div className="overline">Announcement banner · design sketch for your approval (not live yet)</div>
      <p className="text-sm text-muted-foreground">This is how an announcement would appear across the top of every page. Tell me what you'd like changed: colours, wording, size, button or close behaviour.</p>
      <div className="overflow-hidden rounded-md border border-white/10 bg-black">
        {shown ? (
          <div className="flex items-center gap-3 px-4 py-2" style={{ background: "linear-gradient(90deg,#C2A462,#d8bf85)" }} data-testid="announcement-sketch-bar">
            <Megaphone className="h-4 w-4 shrink-0 text-[#0b1428]" />
            <div className="min-w-0 flex-1 truncate text-[13px] text-[#0b1428]"><b>New: Forms now email a PDF copy.</b> Every completed form is saved and emailed automatically.</div>
            <span className="shrink-0 rounded-full border border-[#0b1428]/40 px-3 py-0.5 text-[12px] font-semibold text-[#0b1428]" data-testid="announcement-sketch-read-more">Read more</span>
            <button onClick={() => setShown(false)} className="shrink-0 text-[#0b1428]/70 hover:text-[#0b1428]" data-testid="announcement-sketch-close"><X className="h-4 w-4" /></button>
          </div>
        ) : (
          <button onClick={() => setShown(true)} className="w-full py-2 text-xs text-slate-500 hover:text-[#C2A462]" data-testid="announcement-sketch-show">Closed (it stays closed for that person). Click to show it again</button>
        )}
        <div className="h-20 px-4 py-3 text-xs text-slate-600">Page content…</div>
      </div>
    </div>
  );
}
